import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

export default function LatestSection() {
  const latest = [...articles]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .filter((item) => !item.featured)
    .slice(0, 6);

  return (
    <section className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs tracking-[0.3em] text-secondary-300">LATEST FILES</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">最新入库档案</h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-400">
            按入库时间排序，读者口碑最好的新案与新异闻会优先出现在这里。
          </p>
        </div>
        <Link
          to="/archives"
          className="flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-background-700 px-4 py-2 text-sm text-foreground-200 transition-colors hover:border-primary-400 hover:text-primary-300"
        >
          浏览全部 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {latest.map((article) => (
          <ArticleCard key={article.slug} article={article} />
        ))}
      </div>
    </section>
  );
}